// Domain
import { CurrencyEntity } from '../entities/currency-entity';

export default class State {
  loaded = false;

  items: Array<CurrencyEntity> = [];
}
